import CSS from 'csstype';
import React from 'react';

import { FONT_WEIGHT } from '~/src/dash/components/text/common';
import { Col, Cols, fontSizing, spacing } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';

const days = [
  { label: 'Mon', value: 'Monday' },
  { label: 'Tue', value: 'Tuesday' },
  { label: 'Wed', value: 'Wednesday' },
  { label: 'Thu', value: 'Thursday' },
  { label: 'Fri', value: 'Friday' },
  { label: 'Sat', value: 'Saturday' },
  { label: 'Sun', value: 'Sunday' },
];

const getBorderStyle = (idx: number, isLast?: boolean): CSS.Properties => {
  if (isLast) {
    return {
      borderRadius: '0 5px 5px 0',
      borderLeft: 'none',
    };
  }
  if (idx === 0) {
    return {
      borderRadius: '5px 0 0 5px',
    };
  } else {
    return {
      borderRadius: 'none',
      borderLeft: 'none',
    };
  }
};

interface IProps {
  selected: Set<string>;
  onClick: (value: string) => void;
}

export const DaypartingDayToggles = ({ selected, onClick }: IProps) => {
  return (
    <Cols paddingBottom={spacing.extraSmall} wrap style={{ alignItems: 'center' }}>
      {days.map((day, i) => {
        const isSelected = selected.has(day.value);

        return (
          <Col key={day.label}>
            <button
              onClick={() => onClick(day.value)}
              style={{
                display: 'inline-block',
                textAlign: 'center',
                width: '48px',
                borderWidth: 0,
                lineHeight: 'inherit',
                fontFamily: 'inherit',
                fontStyle: 'inherit',
                whiteSpace: 'nowrap',
                margin: 0,
                backgroundColor: isSelected ? publicaColors.lavender : 'inherit',
                color: isSelected ? publicaColors.veryDarkGray : publicaColors.darkGray,
                transition: 'background 0.2s ease-out',
                minWidth: '40px',
                fontSize: fontSizing.small,
                fontWeight: FONT_WEIGHT.bold,
                border: `1px solid ${publicaColors.lightGray}`,
                padding: '4px 0px',
                cursor: 'pointer',
                ...getBorderStyle(i, i === 6),
              }}
            >
              {day.label}
            </button>
          </Col>
        );
      })}
    </Cols>
  );
};
